import { toast } from 'vue-sonner'

export const ToastService = {

    success(message) {
        toast.success(message)
    },

    error(message) {
        toast.error(message, {
            duration: Infinity
        })
    },

    warning(message) {
        toast.warning(message)
    },

    info(message) {
        toast.info(message)
    },

    loading(message) {
        return toast.loading(message)
    },

    dismiss(id) {
        toast.dismiss(id)
    }
}